import { useIntl } from "react-intl";
import { Modal, Box, Checkbox, Typography, Grid, Button, IconButton } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState, useRef } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
  getFile
} from "../../services/serviceBase";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomTable from "../ui/CustomTable";
import CustomGridCell from "../ui/CustomGridCell";
import CustomInput from "../ui/CustomInput";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-hot-toast";

const AttachmentModal = (props) => {
  const intl = useIntl();

  const modalStyle = {
    position: "relative",
    top: "38%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 1000,
    p: 4,
    borderRadius: "5px",
  };

  const { setLoading } = useLoading();

  const [attachmentData, setAttachmentData] = useState([]);
  const [attachmentsColumns, setAttachmentsColumns] = useState([]);

  const getAttachmentData = () => {
    setLoading(true);
    axios
      .get("/returnFiles/" + props.idReturnFileHead + "/attachments")
      .then((response) => {
        setLoading(false);
        setAttachmentData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getAttachmentColumns = () => {
    setAttachmentsColumns([
      {
        field: "description",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Description" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
      },
      {
        field: "creationDate",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.UploadDate" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
      },
      {
        field: "actionDownload",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Download" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <IconButton
              color="primary"
              component="label"
              disableRipple={true}
              onClick={(e) => handleDownloadAttachmentClick(e, params.row)}
            >
              <AttachFileIcon />
            </IconButton>
          );
        },
      },
      {
        field: "actionDelete",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Delete" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 50,
        renderCell: (params) => {
          return (
            <IconButton
              color="primary"
              component="label"
              disableRipple={true}
              onClick={(e) => handleDeleteAttachmentClick(e, params.row)}
            >
              <DeleteIcon />
            </IconButton>
          );
        },
      },
    ]);
  };

  useEffect(() => {
    if (
      props.idReturnFileHead !== null &&
      props.idReturnFileHead !== undefined &&
      props.idReturnFileHead !== "" &&
      props.openModal
    ) {
      getAttachmentData();
      getAttachmentColumns();
    }
  }, [props.openModal]);

  useEffect(() => {
    getAttachmentColumns();
  }, [attachmentData]);

  const handleClose = () => {
    props.handleCloseModal();
    setAttachmentData([]);
  };

  const attachamentDesc = useRef();
  const fileRef = useRef(null);

  const handleUploadAttachmentClick = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    if (
      attachamentDesc.current.value !== undefined &&
      attachamentDesc.current.value !== ""
    ) {
      params.append("description", attachamentDesc.current.value);
    }

    const data = new FormData();
    data.append("file", fileRef.current.files[0]);
    var url = "/returnFiles/" + props.idReturnFileHead + "/attachments";
    if (params.size > 0) {
      url += "?" + params.toString();
    }
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        toast.success("Uploaded!");
        attachamentDesc.current.value = "";
        fileRef.current.value = "";
        getAttachmentData();
      })
      .catch((error) => {
        handleError(error, intl);
      });
  };

  const handleDeleteAttachmentClick = (e, row) => {
    setLoading(true);
    axios
      .delete(
        "/returnFiles/" +
          row.idReturnFileHead +
          "/attachments/" +
          row.idAttachmentForReturnFileHead
      )
      .then((response) => {
        setLoading(false);
        toast.success("Deleted!");
        getAttachmentData();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleDownloadAttachmentClick = (e, row) => {
    setLoading(true);
    var url =
      "returnFiles/" +
      row.idReturnFileHead +
      "/attachments/" +
      row.idAttachmentForReturnFileHead;
    getFile(
      url,
      (response) => {
        setLoading(false);
        var filename = response.name;
        addDownloadLinkToDocument(
          response,
          "application/octet-stream",
          filename
        );
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      },
      null
    );
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={intl.formatMessage({ id: "RADetails.Attachments" })} />
        <Grid container id="modal-modal-description" sx={{ mt: 2 }}>
          <Grid item md={4.5}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "General.Description",
              })}
              type="text"
              valueRef={attachamentDesc}
            />
          </Grid>
          <Grid item md={5.5}>
            <CustomInput
              labelText={intl.formatMessage({ id: "General.File" })}
              type="file"
              valueRef={fileRef}
            />
          </Grid>
          <Grid item md={1.8} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              className="apeLigthBlueBackground"
              onClick={handleUploadAttachmentClick}
            >
              {intl.formatMessage({ id: "General.Upload" })}
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2 }}>
          <CustomTable
            columns={attachmentsColumns}
            rows={attachmentData}
            id={"idAttachmentForReturnFileHead"}
            rowHeight={40}
            headerHeight={30}
            tableHeight={300}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default AttachmentModal;
